export default __webpack_public_path__ + "static/media/iconHome.be280858.png";